export const DEFAULT_AVATAR_URL = "https://ui-avatars.com/api/?name=Hanimcilar&background=e9d8c0&color=4a3020&bold=true";

export const DEFAULT_ALBUM_COVER_URL = "https://firebasestorage.googleapis.com/v0/b/hanimcilar-9f483.appspot.com/o/default%2Fimages%2Fimage_2023-12-30_131116306.png?alt=media&token=952820c9-9cb3-4021-9465-675f46dfa770";

export const normalizePhotoUrl = (rawUrl?: string | null) => {
    if (!rawUrl) {
        return "";
    }

    const url = rawUrl.trim();
    if (!url) {
        return "";
    }

    if (!url.includes("drive.google.com")) {
        return url;
    }

    const fileIdMatch = url.match(/\/file\/d\/([^/]+)/);
    if (fileIdMatch?.[1]) {
        return `https://drive.google.com/uc?export=view&id=${fileIdMatch[1]}`;
    }

    const openIdMatch = url.match(/[?&]id=([^&]+)/);
    if (openIdMatch?.[1]) {
        return `https://drive.google.com/uc?export=view&id=${openIdMatch[1]}`;
    }

    return url;
};

export const resolveImageUrl = (rawUrl: string | null | undefined, fallbackUrl: string) => {
    const normalized = normalizePhotoUrl(rawUrl);
    return normalized || fallbackUrl;
};
